<template>
  <header class="body-font bg-white rounded-none drop-shadow-md py-4 px-4 font-semibold" :style="themeStyle">
    <div class="container mx-auto flex flex-wrap flex-row">
      <button v-if="back" @click.prevent="router" class="inline-flex items-center border-0 mr-4 text-base">
        <ChevronLeft class="w-4"/>
      </button>
      <p class="general-text">{{ text }}</p>
    </div>
    <p v-if="name" class="text-[24px]">{{ nameVal }}</p>
  </header>
</template>

<script>
import ChevronLeft from '@/components/icons/ChevronLeft.vue';
import { mapActions } from 'vuex';
import { useRoute } from 'vue-router';

export default {
  name: 'MainNavigation',
  props: {
    text: {
      type: String,
      default: '',
    },
    back: {
      type: Boolean,
      default: true,
    },
    link: {
      default: -1,
    },
    size: {
      type: Number,
      default: 20,
    },
    name: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ChevronLeft,
  },
  data() {
    return {
      prevRoute: '',
      nameVal: useRoute().query?.name || '-',
    };
  },
  computed: {
    themeStyle() {
      const defaultStyle = {
        '--text-size': `${this.size}px`,
      };

      return defaultStyle;
    },
  },
  methods: {
    ...mapActions('global', ['setModalSort']),
    router() {
      if (typeof this.link === 'number') {
        this.$router.go(this.link);
      } else {
        this.$router.push(`/${this.link}`);
      }
    },
  },
  created() {
    this.$router.beforeEach((to, from) => {
      this.prevRoute = from.name;
    });
  },
};
</script>

<style lang="scss" scoped>
button {
  position: relative;
}
.general-text {
  font-size: var(--text-size);
}
</style>
